import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const MedianaDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'medianamedianaSearch',
        panelHeader: 'Mitjana',
        panelKey: 'medianamedianaSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nivel',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fechaCreacion',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkAlumno.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkCodigonota.id',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkCompetencia.id',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkDimension.id',
                  yPosition: 3,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkEvaluacion.id',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nivell',
          key: 'nivel',
          type: 'number',
          min: 0,
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Data Creació',
          key: 'fechaCreacion',
          type: 'rangerpicker',
          operand: 'like',
          format: 'timestamp',
          displayFormat: 'DD-MM-YYYY',
        },
        {
          title: 'Alumne',
          key: 'fkAlumno.id',
          type: 'combo',
          operand: 'like',
          comboId: 'alumno',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Codi Nota',
          key: 'fkCodigonota.id',
          type: 'combo',
          operand: 'like',
          comboId: 'codigonota',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Competència',
          key: 'fkCompetencia.id',
          type: 'combo',
          operand: 'like',
          comboId: 'competencia',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Dimensió',
          key: 'fkDimension.id',
          type: 'combo',
          operand: 'like',
          comboId: 'dimension',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Avaluació',
          key: 'fkEvaluacion.id',
          type: 'combo',
          operand: 'like',
          comboId: 'evaluacion',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'medianamedianaList',
        rowKey: 'id',
        panelHeader: 'Mitjana',
        panelKey: 'medianamedianaList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Nom',
          dataIndex: 'nombre',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Nivell',
          dataIndex: 'nivelmediana.nombre',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Data Creació',
          dataIndex: 'fechaCreacion',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'date',
        },
        {
          title: 'Alumne',
          dataIndex: 'fkAlumno.id',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'combo',
          comboId: 'alumno',
        },
        {
          title: 'Codi Nota',
          dataIndex: 'fkCodigonota.codigo',
          position: 5,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 80,
        },
        {
          title: 'Competència',
          dataIndex: 'fkCompetencia.nombre',
          position: 6,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Dimensió',
          dataIndex: 'fkDimension.nombre',
          position: 7,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Avaluació',
          dataIndex: 'fkEvaluacion.nombre',
          position: 8,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'medianamedianaEdit',
        panelHeader: 'Mitjana',
        panelKey: 'medianamedianaEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Mitjana',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nombre',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'nivelmediana.id',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fechaCreacion',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkAlumno.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkCodigonota.id',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkCompetencia.id',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkDimension.id',
                  yPosition: 3,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkEvaluacion.id',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkRegistro.id',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'notaExacta',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'manual',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nom',
          key: 'nombre',
          type: 'text',
          unique: false,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Nivell',
          key: 'nivelmediana.id',
          type: 'combo',
          unique: false,
          comboId: 'nivelmediana',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Data Creació',
          key: 'fechaCreacion',
          type: 'date',
          unique: false,
          format: 'YYYY-MM-DD',
          displayFormat: 'DD-MM-YYYY',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Alumne',
          key: 'fkAlumno.id',
          type: 'combo',
          unique: false,
          comboId: 'alumno',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Codi Nota',
          key: 'fkCodigonota.id',
          type: 'combo',
          unique: false,
          comboId: 'codigonota',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Competència',
          key: 'fkCompetencia.id',
          type: 'combo',
          unique: false,
          comboId: 'competencia',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Dimensió',
          key: 'fkDimension.id',
          type: 'combo',
          unique: false,
          comboId: 'dimension',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Avaluació',
          key: 'fkEvaluacion.id',
          type: 'combo',
          unique: false,
          comboId: 'evaluacion',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Registre',
          key: 'fkRegistro.id',
          type: 'combo',
          unique: false,
          comboId: 'registro',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Nota exacta',
          key: 'notaExacta',
          type: 'number',
          unique: false,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Manual',
          key: 'manual',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          operand: 'like',
          mandatory: true,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'MedianaDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default MedianaDashboard;
